export default __webpack_public_path__ + "static/media/BIDMC.72f35291.jpeg";